import React, { useState, useEffect } from 'react';
import { useAuth, ProtectedRoute } from '../App';
import { Archive as ArchiveIcon, Play } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function ArchivesPage() {
  const [archives, setArchives] = useState([]);

  useEffect(() => {
    const fetchArchives = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/archives`, { credentials: 'include' });
        if (res.ok) setArchives(await res.json());
      } catch (error) {
        console.error('Error fetching archives:', error);
      }
    };
    fetchArchives();
  }, []);

  return (
    <ProtectedRoute>
      <div className="min-h-screen bg-background p-4 md:p-8">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl font-heading font-bold mb-2">Stream Archives</h1>
            <p className="text-muted-foreground">Watch past livestream poker discussions</p>
          </div>

          {archives.length === 0 ? (
            <div className="bg-card border border-border rounded-xl p-12 text-center">
              <ArchiveIcon className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
              <h3 className="text-xl font-heading font-bold mb-2">No archives yet</h3>
              <p className="text-muted-foreground">Past livestreams will appear here</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {archives.map(archive => (
                <a
                  key={archive.archive_id}
                  href={archive.video_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-card border border-border rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all hover:border-primary/50 cursor-pointer"
                  data-testid={`archive-card-${archive.archive_id}`}
                >
                  <div className="relative aspect-video bg-black">
                    {archive.thumbnail_url && (
                      <img src={archive.thumbnail_url} alt={archive.title} className="w-full h-full object-cover" />
                    )}
                    <div className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 hover:opacity-100 transition-opacity">
                      <Play className="w-12 h-12 text-white" />
                    </div>
                    <div className="absolute bottom-2 right-2 bg-black/80 px-2 py-1 rounded text-xs text-white">
                      {archive.duration}
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="font-heading font-semibold mb-2 line-clamp-2">{archive.title}</h3>
                    <p className="text-sm text-muted-foreground line-clamp-2 mb-3">{archive.description}</p>
                    <p className="text-xs text-muted-foreground">
                      {new Date(archive.recorded_at).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
                    </p>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </ProtectedRoute>
  );
}
